<template>
  <div class="wg-row" style="height:calc(100vh - 100px);position:relative;">
    <anm22-dialog-filter 
        v-if="showFilterDialog"
        :allFilters="logFilters" 
        :selected="selectedFilters"
        @applyFilters="filterLogs($event)"
        @closeFilter="showFilterDialog = false;">
    </anm22-dialog-filter>
    <!-- Modale dettagli log -->
    <wg-modal v-if="selected" @closeModal="closeDetails">
      <div slot="header" class="wg-row com-anm22-app-text-xl" style="justify-content:center;">
        {{ $anm22.strLang(lang, 'Log details', 'Dettagli log') }}
      </div>
      <div class="wg-row" slot="body">
        <div class="wg-row">{{ $anm22.strLang(lang, 'Date', 'Data') + ": " + $moment.tz(selected.ts, 'X', timezone).format('DD-MM-YYYY HH:mm') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">{{ $anm22.strLang(lang, 'User', 'Utente') + ": " + getUserName($store.getters['users/get'](selected.user), true) }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">{{ $anm22.strLang(lang, 'Order', 'Ordine') + ": " + selected.order }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">{{ $anm22.strLang(lang, 'Operation', 'Operazione') + ": " + $anm22.tableClasses.foodLogEventType().getById(selected.type)[lang] }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="min-height:100px;border:1px solid #ccc;padding:5px;border-radius:4px;">
          <pre>{{ JSON.stringify(selected.details,null,2) }}</pre>
        </div>
      </div>
    </wg-modal>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'From', 'Da') }}</div>
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input type="date" v-model="from">
      <div class="horizontal-height-div" style="width:10px;"></div>
      <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'To', 'A') }}</div>
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input type="date" v-model="to">
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Update', 'Aggiorna')"
          @click="loadData"
      >
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Filters', 'Filtri')"
          @click="showFilterDialog = true"
      >
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row" style="height:calc(100% - 85px);">
      <w-g-list
          :loading="loading"
          :pagination="true"
          :fieldInit="'ts'"
          :keyField="'id'"
          :clickFn="openDetails"
          :headerItems="headerItems"
          :itemsToDisplay="tableItems"
      >
        <template v-slot:default="{ element, data }">
          <div class="wg-row item-row">
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-l">
                {{ $moment.tz(element.ts, 'X', timezone).format('DD-MM-YYYY HH:mm') }}
              </div>
            </div>
            <div class="wg-col wg-xs-3">
              <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
                <div style="min-width:22px;width:22px;height:22px;">
                  <world-object-icon
                      :type="'user'" 
                      :obj="data.user"
                      :isImg="true">
                  </world-object-icon>
                </div>
                <div class="com-anm22-app-text-l" style="margin-left:5px;">
                  {{ getUserName(data.user, false) }}
                </div>
              </div>
            </div>
            <!-- Numero sequenziale ordine oppure id ordine -->
            <div class="wg-col wg-xs-1">
              <div class="com-anm22-app-text-l">
                {{ element.order }}
              </div>
            </div>
            <div class="wg-col wg-xs-3">
              <div class="com-anm22-app-text-l">
                {{ $anm22.tableClasses.foodLogEventType().getById(element.type)[lang] }}
              </div>
            </div>
            <div class="wg-col wg-xs-1">
              <div class="wg-row" style="justify-content:flex-end">
                <div v-if="element.type <= 3" class="com-anm22-app-text-l">
                  {{ element.details.order.listTotal.toFixed(2) + ' &euro;' }}
                </div>
                <div v-if="element.type === 4" class="com-anm22-app-text-l">
                  {{ element.details.payedTotal.toFixed(2) + ' &euro;' }}
                </div>
                <div v-if="element.type === 5" class="com-anm22-app-text-l">
                  {{ element.details.listTotal.toFixed(2) + ' &euro;' }}
                </div>
                <div v-if="element.type === 6" class="com-anm22-app-text-l">
                  {{ element.details.listPrice.toFixed(2) + ' &euro;' }}
                </div>
                <div v-if="element.type === 9" class="com-anm22-app-text-l">
                  {{ element.details.amount.toFixed(2) + ' &euro;' }}
                </div>
              </div>
            </div>
            <div class="wg-col wg-xs-1">
              <div class="wg-row" style="justify-content:flex-end">
                <div v-if="element.type === 5 || element.type === 6" class="com-anm22-app-text-l">
                  {{ element.details.discount.toFixed(2) + ' &euro;' }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';
import Anm22DialogFilter from '../../../../../world/spa/components/Anm22DialogFilter.vue';

export default {
  props: {
    timezone: {
      type: String
    }
  },
  components: {
    WGList,
    Anm22DialogFilter
  },
  data() {
    return {
      loading: true,
      logs: [],
      from: this.$moment().tz(this.timezone).startOf('day').format('YYYY-MM-DD'),
      to: this.$moment().tz(this.timezone).endOf('day').format('YYYY-MM-DD'),
      selected: null,
      /* Filtraggio mediante impostazioni (con componente separato) */
      showFilterDialog: false,
      selectedFilters: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    logFilters() {
      const filters = [
        /* Progetti con Task assegnati a me */
        {
          id: 'user',
          label: this.$anm22.strLang(this.lang, 'User', 'Utente'),
          type: 'select',
          values: this.logs
          .reduce((res,log) => {
            if(!res.find(u => u.idWorldUser === log.user)) {
              return res.concat(this.$store.getters['users/get'](log.user));
            } else {
              return res;
            }
          }, [])
          .map(user => {
            return {
              label: user.name + ' ' + user.surname,
              value: user.idWorldUser
            }
          }),
          apply: (log, userId) => {
            return log.user == userId;
          }
        },
        {
          id: 'type',
          label: this.$anm22.strLang(this.lang, 'Type', 'Tipologia'),
          type: 'select',
          values: [
            ...Object.values(this.$anm22.tableClasses.foodLogEventType().getAll())
              .map(type => {
                return {
                  label: type[this.lang],
                  value: type.typeClass
                }
              }),
              {
                label: this.$anm22.strLang(this.lang, 'All discounts', 'Tutti gli sconti'),
                value: 'discounts'
              },
            ],
          apply: (log, type) => {
            if(type === 'discounts') {
              return log.type == 5 || log.type == 6;
            }
            return log.type == type;
          }
        }
      ];
      return filters;
    },
    headerItems: function() {
      return [
        {
          field: 'ts',
          label: this.$anm22.strLang(this.lang, 'Data', 'Data'),
          class: 'wg-xs-3',
          disabled: false,
        },
        {
          field: 'user',
          label: this.$anm22.strLang(this.lang, 'User', 'Utente'),
          class: 'wg-xs-3',
          disabled: false,
        },
        {
          field: 'order',
          label: this.$anm22.strLang(this.lang, 'Order', 'Ordine'),
          class: 'wg-xs-1',
          disabled: false,
        },
        {
          field: 'type',
          label: this.$anm22.strLang(this.lang, 'Operation', 'Operazione'),
          class: 'wg-xs-3',
          disabled: false,
        },
        {
          field: 'value',
          label: this.$anm22.strLang(this.lang, 'Value', 'Valore'),
          class: 'wg-xs-1',
          disabled: false,
        },
        {
          field: 'discount',
          label: this.$anm22.strLang(this.lang, 'Discount', 'Sconto'),
          class: 'wg-xs-1',
          disabled: false,
        }
      ];
    },
    tableItems: function() {
      if(this.logs) {
        return this.logs
          .filter(log => {
            return log && !Array.isArray(log) && log.details && Object.keys(log.details).length > 0
              && this.selectedFilters
                .reduce(
                  (result, selectedFilter) => {
                    const filter = this.logFilters.find(f => f.id === selectedFilter.id);
                    // Check if this work offers this filter
                    if(filter) {
                      return result && filter.apply(log, selectedFilter.value);
                    } else {
                      return result;
                    }
                  }, 
                  true
                );
          })
          .map(l => {
            const user = this.$store.getters['users/get'](l.user);
            return {
              ...l,
              'list-metadata': {
                type: 'item',
                user
              }
            };
          });
      } else {
        return [];
      }
    }
  },
  methods: {
    filterLogs(newFilters) {
      /* Save filters in cookie */
      // this.$anm22.setCookie(
      //   'tk-p-filters', 
      //   JSON.stringify(newFilters.reduce((r,f) => {
      //     r.push([f.id, f.value]);
      //     return r;
      //   }, [])), 
      //   31536000
      // );
      this.selectedFilters = newFilters;
      this.showFilterDialog = false;
    },
    openDetails(log) {
      this.selected = log;
    },
    closeDetails() {
      this.selected = null;
    },
    loadData() {
      this.loading = true;
      this.$http.get('settings/logs?from='+this.from+'&to='+this.to)
      .then(response => {
        this.logs = response.data.logs;
        this.$store.dispatch('users/update', {
          vlf: this.$vlf('users'), objs: response.data.users
        })
        .then(() => {
          this.$Progress.finish();
          this.loading = false;
        })
      })
      .catch(e => console.log(e));
    },
    getUserName(user, full) {
      if(user) {
        if(full) {
          return user.name + ' ' + user.surname;
        } else {
          return user.name.substring(0,1) + '. ' + user.surname;
        }
      } else {
        return this.$anm22.strLang(this.lang, 'User', 'Utente');
      }
    },
  },
  created() {
    this.$Progress.start();
    this.loadData();
  },
}
</script>

<style lang="scss" scoped>
.item-row {
  height: 36px;
  padding: 10px;
  &:hover {
    background-color: #fff;
  }
}
</style>
